import tokenService from '../_services/token.service';
import { decodeToken } from '../models/decode-token';

export const checkIfCompanyToken = () => {
  const token = tokenService.getLocalAccessToken();
  const decodedToken = decodeToken(token);
  return decodedToken?.company_id;
};
